import React, { useState, useEffect, useCallback, useMemo } from "react";
import {
  Checkbox,
  Typography,
  MenuItem,
  Select,
  FormControl,
  IconButton,
  makeStyles
} from "@material-ui/core";
import clsx from "clsx";
import { connect } from "react-redux";
import EditIcon from "@material-ui/icons/Edit";
import ToggleOffIcon from "@material-ui/icons/ToggleOff";
import ToggleOnIcon from "@material-ui/icons/ToggleOn";
import OptimizedTooltip from "../common/OptimizedTooltip";
import SmallSearchBox from "../common/SmallSearchBox";
// import FilterIcon from "../icons/FilterIcon";
import { setExtendableId, setExtendableType } from "../../store/actions/edit";
import { deselectVehicle, setVehicles } from "../../store/actions/project";
import {
  setCurrentVehicleSelection,
  setFilterStatus,
  filterVehiclesByStatus
} from "../../store/actions/common";
import { completedStopsCount } from "../../utils/helpers";
import { setSelectedVehiclesChange } from "../../store/actions/custom";
import { setInfoDialog } from "../../store/actions/common";
import ConfirmDialog from "../dialogs/ConfirmDialog";
// const VEHICLE_STATES = ["All vehicles", "Enabled", "Disabled"];

const useStyles = makeStyles(theme => ({
  toolbarWrapper: {
    minHeight: 40,
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    padding: theme.spacing(2, 2, 2, 3),
    "& > div": {
      display: "flex",
      width: "100%",
      alignItems: "center"
    },
    "& > div:last-child": {
      justifyContent: "space-between"
    }
  },
  countIndicator: {
    fontSize: "0.875rem",
    lineHeight: "1.5rem",
    fontWeight: 500,
    color: "#4D4D50",
    padding: theme.spacing(1, 2, 0.5, 3)
  },
  chip: {
    height: 14,
    width: 14,
    background: "#7D7E82",
    borderRadius: theme.spacing(0.25),
    fontWeight: 500,
    fontSize: "0.75rem",
    lineHeight: "0.875rem",
    display: "inline-block",
    textAlign: "center"
  },
  toolbarActions: {
    minHeight: 40,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(3),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  checkboxWrapper: {
    display: "flex",
    alignItems: "center",
    marginLeft: theme.spacing(-1),
    "& .MuiSvgIcon-root": {
      color: theme.palette.primary.main
    }
  },
  searchBox: {
    height: 40,
    width: ({ showSearchField }) => (showSearchField ? 256 : "98%")
  },
  formControl: {
    "& .MuiSelect-select": {
      padding: theme.spacing(0),
      "&:focus": {
        backgroundColor: "unset"
      }
    },
    "& .MuiSelect-icon": {
      display: "none"
    },
    "& .MuiSelect-selectMenu": {
      // overflow: "unset"
    }
  },
  selectedText: {
    marginLeft: theme.spacing(1),
    color: theme.palette.primary.main,
    fontWeight: 500,
    fontSize: "0.875rem",
    lineHeight: "1rem"
  },
  selectBox: {
    width: 256,
    borderRadius: "4px",
    marginTop: theme.spacing(0.5),
    border: "1px solid #EAEBF0",
    boxSizing: "border-box",
    boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.16)",
    "& .MuiListItem-root.Mui-selected": {
      backgroundColor: "#F4F4F4"
    },
    "& ul": {
      paddingTop: theme.spacing(0.75),
      paddingBottom: theme.spacing(0.75)
    },
    "& li": {
      minHeight: 40
    }
  },
  button: {
    marginLeft: theme.spacing(1.5)
  },
  toolbarButtonDisabled: {
    "& svg": {
      color: "#DADADA"
    },
    cursor: `${theme.cursors.notAllowed} !important`
  },
  animatedItem: {
    animation: `$moveInRight 0.5s ${theme.transitions.easing.easeInOut}`
  },
  "@keyframes moveInRight": {
    "0%": {
      opacity: 0,
      transform: "translateX(256px)"
    },
    "100%": {
      opacity: 1,
      transform: "translateX(0)"
    }
  }
}));

const VehiclesToolbar = ({
  vehicles,
  vehicleTypes,
  filterStatus,
  hasEnabledVehicles,
  // setExtendableId,
  // setExtendableType,
  setFilterStatus,
  currentVehicleSelection,
  setCurrentVehicleSelection,
  filterVehiclesByStatus,
  setFilteredVehicles,
  sortVehiclesByName,
  setVehicleFilterText,
  vehicleFilterText,
  filteredVehicles,
  solution,
  setSelectedVehiclesChange,
  setInfoDialog,
  editId,
  filteredCurrentVehicleSelection,
  warnEdit
}) => {
  const [selectedStatus, setSelectedStatus] = useState(filterStatus);
  const [showSearchField, setShowSearchField] = useState(false);
  // const [open, setOpen] = useState(false);
  const [shouldOpenConfirmDialog, setShouldOpenConfirmDialog] = useState(false);

  const classes = useStyles({ showSearchField });

  const numSelected = filteredCurrentVehicleSelection.length;

  // const filteredVehicleTypes =
  //   filteredVehicles.length === vehicleTypes
  //     ? vehicleTypes.filter(vehicleType =>
  //         filteredVehicles.find(vehicle => vehicle.id === vehicleType.id)
  //       )
  //     : vehicleTypes;

  const {
    hasCompletedStops,
    currentVehicleSelectionWithoutStartedRoutes,
    isCurrentVehicleSelectionHasRoute,
    isInCurrentVehicleSelectionHasLocked
  } = useMemo(() => {
    let isCurrentVehicleSelectionHasRoute;
    let isInCurrentVehicleSelectionHasLocked;
    // Remove all from currentSelection routes whitch started their route
    const currentVehicleSelectionWithoutStartedRoutes =
      filteredCurrentVehicleSelection.filter(typeId => {
        const vehicle = vehicles.find(
          vehicle => vehicle?.type_id?.id === typeId
        );
        const route =
          solution?.routes?.find(
            route => route.vehicle_id === vehicle?.vehicle_id
          ) || [];

        //Just check one time
        if (!isCurrentVehicleSelectionHasRoute && route?.stops) {
          isCurrentVehicleSelectionHasRoute = route?.stops?.length > 2;
        }
        if (!isInCurrentVehicleSelectionHasLocked && route?.locked) {
          isInCurrentVehicleSelectionHasLocked = route?.locked;
        }
        return completedStopsCount(route?.stops) === 0;
      });

    return {
      // Check if there is completed stops
      hasCompletedStops:
        (currentVehicleSelectionWithoutStartedRoutes.length > 0 &&
          currentVehicleSelectionWithoutStartedRoutes.length <
            filteredCurrentVehicleSelection.length) ||
        (filteredCurrentVehicleSelection.length === 1 &&
          currentVehicleSelectionWithoutStartedRoutes.length !==
            filteredCurrentVehicleSelection.length),
      currentVehicleSelectionWithoutStartedRoutes,

      isCurrentVehicleSelectionHasRoute,

      isInCurrentVehicleSelectionHasLocked
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filteredCurrentVehicleSelection, solution]);

  // const handleClose = () => {
  //   setOpen(false);
  // };

  // const handleOpen = () => {
  //   setOpen(true);
  // };

  const handleSelectAllClick = event => {
    if (event.target.checked) {
      const newSelected = filteredVehicles.map(vehicleType => vehicleType.id);

      setCurrentVehicleSelection(newSelected);
      return;
    }
    setCurrentVehicleSelection([]);
  };

  const handleControlA = useCallback(
    event => {
      if (event.keyCode === 17) return false;

      if (event.ctrlKey) {
        if (event.keyCode === 65 || event.keyCode === 97) {
          if (editId) return;
          event.preventDefault();
          const newSelected = filteredVehicles.map(
            vehicleType => vehicleType.id
          );
          setCurrentVehicleSelection(newSelected);
          return;
        }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    [editId, filteredVehicles]
  );

  useEffect(() => {
    document.addEventListener("keydown", handleControlA, false);

    return () => {
      document.removeEventListener("keydown", handleControlA, false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editId]);

  const handleBulkEditClick = () => {
    warnEdit("multiple");
  };

  const handleSearchChange = val => {
    setVehicleFilterText(val);
  };

  const handleFilter = (vehicleType, value) =>
    (vehicleType.name || "").toLowerCase().indexOf(value.toLowerCase()) !== -1;

  useEffect(() => {
    setFilteredVehicles(
      sortVehiclesByName(
        vehicleTypes.filter(vehicleType =>
          handleFilter(vehicleType, vehicleFilterText)
        )
      )
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vehicleTypes, vehicleFilterText]);

  useEffect(() => {
    filterVehiclesByStatus(filterStatus);
    setSelectedStatus(filterStatus);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vehicles, filterStatus]);

  useEffect(() => {
    if (!numSelected) setShowSearchField(false);
  }, [numSelected]);

  //Don't remove 1.16+
  // const renderValue = () => {
  //   return (
  //     <IconButton variant="outlined" className={classes.button}>
  //       <FilterIcon />
  //     </IconButton>
  //   );
  // };

  const allVehiclesSelected =
    filteredVehicles.length > 0 && numSelected === filteredVehicles.length;

  const enabledVehiclesCount = vehicles
    .map(vehicle => ({
      id: vehicle?.type_id?.id,
      isSelected: vehicle.selected
    }))
    .filter(vehicle =>
      filteredVehicles.find(
        filteredVehicle =>
          filteredVehicle.id === vehicle.id && vehicle.isSelected
      )
    ).length;

  const handleSelectedVehiclesChange = () => {
    if (hasEnabledVehicles) {
      setShouldOpenConfirmDialog(true);
    } else {
      setSelectedVehiclesChange(filteredCurrentVehicleSelection, "enable");
    }
  };

  return (
    <>
      <div className={classes.toolbarWrapper}>
        <div>
          <SmallSearchBox
            isEnhancedSearch
            placeholder="Search vehicles"
            className={classes.searchBox}
            searchText={vehicleFilterText}
            onSearchChanged={handleSearchChange}
            ariaLabel="Search vehicles"
            dataCy="vehicles-search"
          />
          {/*
          Don't remove this might would neccessary to use in upcoming versions when need to implement filter select feature;
          <FormControl className={classes.formControl}>
          {/* <FormControl className={classes.formControl}>
            <Select
              elevation={0}
              disableUnderline
              value={selectedStatus}
              renderValue={() => renderValue()}
              onChange={e => {
                setSelectedStatus(e.target.value);
                setFilterStatus(e.target.value);
              }}
              open={open}
              onClose={handleClose}
              onOpen={handleOpen}
              MenuProps={{
                classes: { paper: classes.selectBox },
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "right"
                },
                transformOrigin: {
                  vertical: "top",
                  horizontal: "right"
                },
                getContentAnchorEl: null
              }}
            >
              {VEHICLE_STATES.map(item => {
                return (
                  <MenuItem key={item} value={item}>
                    {item}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl> */}
        </div>
      </div>
      {!!numSelected && (
        <div className={classes.toolbarActions}>
          <div className={classes.checkboxWrapper}>
            <OptimizedTooltip
              title={allVehiclesSelected ? "Deselect all" : <>Select all</>}
              placement="bottom"
            >
              <Checkbox
                color="primary"
                indeterminate={
                  numSelected > 0 && numSelected < vehicleTypes.length
                }
                checked={allVehiclesSelected}
                onChange={handleSelectAllClick}
                onClick={e => e.stopPropagation()}
              />
            </OptimizedTooltip>
            <Typography className={classes.selectedText}>
              {numSelected} selected
            </Typography>
          </div>
          <div>
            <OptimizedTooltip
              placement="bottom"
              title={
                isInCurrentVehicleSelectionHasLocked
                  ? "Unable to disable locked vehicles"
                  : hasEnabledVehicles
                  ? "Disable"
                  : "Enable"
              }
            >
              <span
                className={clsx({
                  [classes.toolbarButtonDisabled]:
                    isInCurrentVehicleSelectionHasLocked
                })}
              >
                <IconButton
                  onClick={() => handleSelectedVehiclesChange()}
                  disabled={isInCurrentVehicleSelectionHasLocked}
                >
                  {hasEnabledVehicles ? <ToggleOffIcon /> : <ToggleOnIcon />}
                </IconButton>
              </span>
            </OptimizedTooltip>
            <OptimizedTooltip
              placement="bottom"
              title={
                hasCompletedStops || isInCurrentVehicleSelectionHasLocked
                  ? `Unable to edit vehicle${
                      filteredCurrentVehicleSelection.length > 1 ? "s" : ""
                    } that locked or started their route`
                  : `Edit vehicle${
                      filteredCurrentVehicleSelection.length > 1 ? "s" : ""
                    }`
              }
            >
              <span
                className={clsx({
                  [classes.toolbarButtonDisabled]:
                    hasCompletedStops || isInCurrentVehicleSelectionHasLocked
                })}
              >
                <IconButton
                  onClick={handleBulkEditClick}
                  disabled={
                    hasCompletedStops || isInCurrentVehicleSelectionHasLocked
                  }
                >
                  <EditIcon />
                </IconButton>
              </span>
            </OptimizedTooltip>
          </div>
        </div>
      )}
      {((vehicleFilterText.trim().length > 0 && filteredVehicles.length > 0) ||
        vehicleFilterText === "") && (
        <Typography className={classes.countIndicator}>
          {`Enabled vehicles (${
            enabledVehiclesCount > 0 ? enabledVehiclesCount : 0
          }/${filteredVehicles.length})`}
        </Typography>
      )}
      <ConfirmDialog
        title="Disable all selected vehicles?"
        body={
          isCurrentVehicleSelectionHasRoute ? 
            "When disabling a vehicle, all stops associated with a vehicle's route will be moved to unscheduled." : 
            "Are you sure you want to disable this vehicles? This vehicles will not be taken into account during the optimization."
        }
        confirmText="Disable"
        open={shouldOpenConfirmDialog}
        action={() => {
          if (isCurrentVehicleSelectionHasRoute) {
            Promise.resolve()
            .then(() => {
              setSelectedVehiclesChange(
                currentVehicleSelectionWithoutStartedRoutes,
                "disable"
              );
            })
            .then(() => {
              currentVehicleSelectionWithoutStartedRoutes.length <
                numSelected &&
                setTimeout(() => {
                  setInfoDialog({
                    title: "Not all vehicles were disabled",
                    body: "You can’t disable vehicles which started their route.",
                    visible: true,
                    mainButtonVariant: "contained"
                  });
                }, 2000);
            });
          } else {
            setSelectedVehiclesChange(filteredCurrentVehicleSelection, "disable")
          }
        }}
        handleClose={() => setShouldOpenConfirmDialog(false)}
        modalType="confirmDisableScheduledRoute"
      />
    </>
  );
};

function mapStateToProps(state) {
  return {
    vehicles: state.project.vehicles,
    vehicleTypes: state.project.vehicleTypes,
    // currentVehicleSelection: state.common.currentVehicleSelection,
    selectedVehicles: state.project.selectedVehicles,
    filterStatus: state.common.filterStatus,
    solution: state.project.solution,
    hasEnabledVehicles: state.common.currentVehicleSelection.some(item =>
      state.project.vehicles.some(el => el.type_id.id === item)
    ),
    editId: state.extendable.id
  };
}

export default connect(mapStateToProps, {
  setVehicles,
  deselectVehicle,
  // setExtendableId,
  // setExtendableType,
  setFilterStatus,
  filterVehiclesByStatus,
  setCurrentVehicleSelection,
  setSelectedVehiclesChange,
  setInfoDialog
})(VehiclesToolbar);
